import script from "./OcrVerificationProductsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrVerificationProductsTable.vue?vue&type=script&setup=true&lang=ts"

import "./OcrVerificationProductsTable.vue?vue&type=style&index=0&id=3e6d096f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6d096f"]])

export default __exports__